import styles from './CampaignCardSkeleton.module.css';

export default function CampaignCardSkeleton() {
  return (
    <div className={styles.card} aria-hidden="true">
      <div className={`${styles.thumb} ${styles.shimmer}`} />
      <div className={styles.info}>
        <span className={`${styles.line} ${styles.lineBrand} ${styles.shimmer}`} />
        <span className={`${styles.line} ${styles.shimmer}`} />
        <span className={`${styles.line} ${styles.lineShort} ${styles.shimmer}`} />
      </div>
    </div>
  );
}

export function CampaignCardSkeletonGrid({ count = 8 }) {
  return Array.from({ length: count }, (_, i) => <CampaignCardSkeleton key={i} />);
}
